import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/biller`;

// Old implementation - commented out as backend sends all items by default
// export const listAll = (name, pageSize, pageNo, sortFitler, sortOrder) => {
//   let url =
//     PREFIX +
//     `/list?name=${name}&sortKey=${sortFitler}&page=${pageNo}&size=${pageSize}&sortOrder=${sortOrder}`;
//
//   return axiosInstance.get(url);
// };

// Simplified implementation - backend sends all items without pagination params
export const listAll = () => {
  return axiosInstance.get(PREFIX + '/list');
};
export const AddBiller = data => {
  return axiosInstance.post(PREFIX, data);
};
// export const assignJobtobiller = jobId => {
//   return axiosInstance.post(PREFIX + `/job/assign?jobId=${jobId}`);
// };
export const AddBillerinUser = page => {
  return axiosInstance.get(PREFIX + `?page=${page}&size=100 `);
};
export const getCptCodes = jobId => {
  return axiosInstance.get(
    PREFIX + `/cpt-code?jobId=${jobId}&overWriteExisting=${false} `
  );
};

export const billiersJobList = (
  name,
  pageSize,
  pageNo,
  sortFitler,
  sortOrder,
  createdFrom = '',
  createdTill = ''
) => {
  let url =
    PREFIX +
    `/jobs/list?searchValue=${name}&page=${pageNo}&size=${pageSize}&sortKey=${sortFitler}&sortOrder=${sortOrder}`;

  if (createdFrom) url += `&createdFrom=${createdFrom}`;
  if (createdTill) url += `&createdTill=${createdTill}`;

  return axiosInstance.get(url);
};
export const fetchJobsForBillersAudit = payload => {
  return axiosInstance.post(PREFIX + `/jobs/audit`, payload);
};
export const fetchDoctors = () => {
  return axiosInstance.get(PREFIX + `/doctors`);
};
export const assignJobtobiller = jobId => {
  return axiosInstance.post(PREFIX + `/job/assign?jobId=${jobId}`);
};
export const releaseJobFromBiller = jobId => {
  return axiosInstance.post(PREFIX + `/job/release?jobId=${jobId}`);
};
export const editBiller = data => {
  return axiosInstance.put(PREFIX, data);
};
export const getCptReferences = () => {
  return axiosInstance.get(PREFIX + '/cpt-references');
};
export const updateCptCodes = (data, sessionId) => {
  return axiosInstance.put(PREFIX + `/cpt-codes?sessionId=${sessionId}`, data);
};
